//
// Generated class DBDocumentLine
//

/// <reference path="DBDocumentLine_ManagedObject.ts" />

class DBDocumentLine extends DBDocumentLine_ManagedObject
{
}
